import { IotsUptimeByTypeListChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { formatIotTypeLabel } from '../format-iot-type-label';
import { useLast30DaysHardwareIotsUptimeByTypeListChart } from './use-last-30-days-hardware-iots-uptime-by-type-list-chart';

export interface Last30DaysHardwareIotsUptimeByTypeListChartProps {
    accountId: string;
}

export const Last30DaysHardwareIotsUptimeByTypeListChart = (props: Last30DaysHardwareIotsUptimeByTypeListChartProps) => {
    const { data, isLoading } = useLast30DaysHardwareIotsUptimeByTypeListChart(props);

    return (
        <StatisticsCard
            chartKey={IotsUptimeByTypeListChart.definition.key}
            title={
                <FormattedMessage
                    id='platform.statistics.hardware.last-30-days-hardware-iots-uptime-by-type-list-chart.title'
                    description='Title of the hardware insights list showing average uptime percentage by IoT device type'
                    defaultMessage='Uptime by type'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.statistics.hardware.last-30-days-hardware-iots-uptime-by-type-list-chart.subtitle'
                    description='Subtitle for the hardware uptime-by-type list indicating the last 30 days window'
                    defaultMessage='Last 30 days'
                />
            }
            isLoading={isLoading}
            hasData={!!data}>
            {data && (
                <div className='min-h-0 flex-1 overflow-y-auto'>
                    <IotsUptimeByTypeListChart
                        data={data}
                        renderItem={(item) => (
                            <div className='flex w-full items-center justify-between gap-3'>
                                <div className='text-foreground-default min-w-0 text-base font-medium'>{formatIotTypeLabel(item.name)}</div>
                                <span className='text-background-surface bg-brand-muted inline-flex min-w-8 shrink-0 items-center justify-center rounded-full px-2 py-0.5 text-sm font-semibold'>
                                    {Math.round(item.value)}%
                                </span>
                            </div>
                        )}
                    />
                </div>
            )}
        </StatisticsCard>
    );
};
